// 树形结构查找祖先节点的 ID列表（包括根节点）
export function findAllAncestorIds (tree, targetId, ancestors = []) {
    function search (node, target) {
        if (!node) return;
        if (node.id === target) {
            ancestors.unshift(node.id); // 将当前节点 ID 添加到祖先列表的开头
            return true; // 找到目标节点，返回 true
        }
        for (const child of node.children || []) {
            if (search(child, target)) {
                ancestors.unshift(node.id); // 将当前节点（父节点）的 ID 也添加到祖先列表中
                return true; // 继续向上递归，直到根节点或找到目标节点的所有祖先
            }
        }
    }
    for (const node of tree) {
        search(node, targetId); // 对每个根节点开始搜索
        if (ancestors.length > 0) break; // 如果已经找到祖先，则停止遍历其他根节点
    }
    return ancestors.length > 0 ? ancestors : []; // 返回祖先节点 ID 列表或 []（如果没有找到）
}
// 树形结构查找子节点ids列表
export function findAllChildIds (nodes, id) {
    let children = [];
    function findChildren (nodes, id) {
        nodes.forEach(node => {
            if (node.pid === id) {
                children.push(node.id);
                if (node.children && node.children.length > 0) {
                    findChildren(node.children, node.id);
                }
            } else {
                if (node.children && node.children.length > 0) {
                    findChildren(node.children, id);
                }
            }
        });
    }
    findChildren(nodes, id);
    return children;
}
// 树形结构转列表
export function treeToList (tree) {
    let list = []
    function traverse (node) {
        let children = []
        if (node.children) {
            children = node.children
        }
        delete node.children
        list.push(node)
        if (children.length > 0) {
            children.forEach(child => traverse(child))
        }
    }
    for (const node of tree) {
        traverse(node)
    }
    return list
}

